<template>
  <select-field
    :title="$t('pages.incomes.date_group_by')"
    :id="id"
    :form="form"
    :name="name"
    :options="options"
  ></select-field>
</template>

<script>
import Form, { SelectField } from "../../../components/form";

import {
  EXPENSE_DATE_GROUP_BY_DAY,
  EXPENSE_DATE_GROUP_BY_MONTH,
  EXPENSE_DATE_GROUP_BY_YEAR
} from "../../constants";

export default {
  components: {
    SelectField
  },
  props: {
    form: {
      type: Form,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      options: [
        {
          id: EXPENSE_DATE_GROUP_BY_DAY,
          label: this.$t("pages.incomes.date_group_by_day")
        },
        {
          id: EXPENSE_DATE_GROUP_BY_MONTH,
          label: this.$t("pages.incomes.date_group_by_month")
        },
        {
          id: EXPENSE_DATE_GROUP_BY_YEAR,
          label: this.$t("pages.incomes.date_group_by_year")
        }
      ]
    };
  },
  methods: {
    init() {
      if (!this.$isset(this.form[this.name])) {
        this.form[this.name] = this.options[0];
      }
    }
  }
};
</script>

<style>
</style>